import EditorBox from "./EditorBox";

export default EditorBox;
export { EditorBox };
